import { useRef, useState, useCallback, useEffect } from "react";
import {
  getSearchPayloadForPrivate,
  getSearchResultsWithPaginationForPrivate,
} from "services";
import { transformPrivateProperties } from "../utils/transformPrivateProperties";
import { AUCTION_PAGE_SIZE } from "../../../propertyListingV2/constants/auction";

export const usePrivatePLSearch = ({
  router,
  searchForm,
}: {
  router: any;
  searchForm: any;
}) => {
  const requestIdRef = useRef(0);

  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [noMore, setNoMore] = useState(false);

  const fetchPage = useCallback(
    async (pageToFetch: number, reset = false) => {
      const requestId = ++requestIdRef.current;
      setLoading(true);

      if (reset) {
        setData([]);
        setPage(1);
        setNoMore(false);
        searchForm.setField("total", 0);
      }

      try {
        const payload = getSearchPayloadForPrivate(
          searchForm,
          router,
          pageToFetch,
        );
        const res: any = await getSearchResultsWithPaginationForPrivate(
          { searches: payload },
          AUCTION_PAGE_SIZE,
          pageToFetch,
        );

        if (requestId !== requestIdRef.current) return;

        const hits = res?.results?.[0]?.hits?.map((h: any) => h.document);
        const found = res?.results?.[0]?.found ?? 0;

        searchForm.setField("total", found);

        const transformed = transformPrivateProperties(hits);

        setData((prev) =>
          pageToFetch === 1 ? transformed : [...prev, ...transformed],
        );

        setPage(pageToFetch);

        if (!hits?.length || transformed?.length < AUCTION_PAGE_SIZE) {
          setNoMore(true);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching private properties:", err);
        setLoading(false);
      }
    },
    [router, searchForm],
  );

  return {
    data,
    loading,
    noMore,
    page,
    fetchFirstPage: () => fetchPage(1, true),
    fetchNextPage: () => fetchPage(page + 1),
  };
};
